import React from 'react';
import {
  Box, VStack, HStack, Heading, Text, Button, SimpleGrid, Card, CardBody,
  Icon, List, ListItem, ListIcon, Flex, Divider,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import {
  MdSportsSoccer, MdVolunteerActivism, MdVerifiedUser, MdSchool,
  MdHowToReg, MdPlace, MdAccessTime, MdSupportAgent,
} from 'react-icons/md';
import { CheckCircleIcon } from '@chakra-ui/icons';

const Portal2026Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box minH="100vh" bg="gray.50">
      {/* Header institucional */}
      <Box bg="#5b182b" py={8} px={{ base: 4, md: 10 }} color="white" textAlign="center">
        <Flex justify="center" align="center" mb={2}>
          <Box bg="white" borderRadius="full" w={14} h={14} display="flex" alignItems="center" justifyContent="center" mr={4}>
            <Icon as={MdSupportAgent} color="#5b182b" boxSize={8} />
          </Box>
          <Box textAlign="left">
            <Heading size="lg">Portal Ciudadano</Heading>
            <Text fontSize="sm" opacity={0.85}>Deportes e Instancia Municipal de la Mujer</Text>
          </Box>
        </Flex>
        <Text fontSize="sm" opacity={0.75} mt={2}>H. Ayuntamiento de Totolac · Tlaxcala</Text>
      </Box>

      <Box py={10} px={{ base: 4, md: 10 }} maxW="1000px" mx="auto">
        <VStack spacing={8}>
          <Box textAlign="center">
            <Heading size="md" color="gray.700">¿Qué desea realizar?</Heading>
            <Text color="gray.500" mt={1} fontSize="sm">Seleccione el trámite o servicio que necesita.</Text>
          </Box>

          {/* DEPORTES */}
          <Box w="full">
            <HStack mb={3}>
              <Icon as={MdSportsSoccer} color="#5b182b" boxSize={6} />
              <Heading size="sm" color="#5b182b">Dirección de Deportes</Heading>
            </HStack>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} w="full">
              <Card shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s" cursor="pointer"
                onClick={() => navigate('/portal/deportes/convocatorias')}>
                <CardBody p={6}>
                  <HStack spacing={4} mb={4}>
                    <Box bg="green.100" borderRadius="full" p={3}>
                      <Icon as={MdSportsSoccer} color="green.500" boxSize={7} />
                    </Box>
                    <Box>
                      <Heading size="sm" color="green.600">Convocatorias</Heading>
                      <Text fontWeight="bold" color="gray.700">Vigentes</Text>
                    </Box>
                  </HStack>
                  <Text fontSize="sm" color="gray.600" mb={4}>
                    Consulte las convocatorias deportivas vigentes, sus requisitos y descargue los documentos oficiales.
                  </Text>
                  <List spacing={1} mb={4}>
                    <ListItem fontSize="xs" color="gray.500"><ListIcon as={CheckCircleIcon} color="green.400" />Disciplinas y categorías</ListItem>
                    <ListItem fontSize="xs" color="gray.500"><ListIcon as={CheckCircleIcon} color="green.400" />Fechas y requisitos</ListItem>
                  </List>
                  <Button colorScheme="green" size="sm" w="full">Ver Convocatorias →</Button>
                </CardBody>
              </Card>

              <Card shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s" cursor="pointer"
                onClick={() => navigate('/portal/deportes/inscripcion')}>
                <CardBody p={6}>
                  <HStack spacing={4} mb={4}>
                    <Box bg="teal.100" borderRadius="full" p={3}>
                      <Icon as={MdHowToReg} color="teal.500" boxSize={7} />
                    </Box>
                    <Box>
                      <Heading size="sm" color="teal.600">Inscripción</Heading>
                      <Text fontWeight="bold" color="gray.700">Deportiva</Text>
                    </Box>
                  </HStack>
                  <Text fontSize="sm" color="gray.600" mb={4}>
                    Inscríbase en línea a una convocatoria deportiva y reciba su folio de confirmación.
                  </Text>
                  <List spacing={1} mb={4}>
                    <ListItem fontSize="xs" color="gray.500"><ListIcon as={CheckCircleIcon} color="teal.400" />Registro del aspirante</ListItem>
                    <ListItem fontSize="xs" color="gray.500"><ListIcon as={CheckCircleIcon} color="teal.400" />Folio inmediato</ListItem>
                  </List>
                  <Button colorScheme="teal" size="sm" w="full">Inscribirme →</Button>
                </CardBody>
              </Card>
            </SimpleGrid>
          </Box>

          <Divider />

          {/* IMM */}
          <Box w="full">
            <HStack mb={3}>
              <Icon as={MdVolunteerActivism} color="#5b182b" boxSize={6} />
              <Heading size="sm" color="#5b182b">Instancia Municipal de la Mujer</Heading>
            </HStack>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={5} w="full">
              <Card shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s" cursor="pointer"
                onClick={() => navigate('/portal/imm/solicitud')}>
                <CardBody p={5}>
                  <HStack spacing={3} mb={3}>
                    <Box bg="pink.100" borderRadius="full" p={2}>
                      <Icon as={MdVolunteerActivism} color="pink.500" boxSize={6} />
                    </Box>
                    <Text fontWeight="bold" color="gray.700">Solicitar Auxilio</Text>
                  </HStack>
                  <Text fontSize="sm" color="gray.500" mb={3}>
                    Solicite apoyo o acompañamiento de la Instancia Municipal de la Mujer de forma confidencial.
                  </Text>
                  <Button colorScheme="pink" variant="outline" size="sm" w="full">Solicitar →</Button>
                </CardBody>
              </Card>

              <Card shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s" cursor="pointer"
                onClick={() => navigate('/portal/imm/talleres')}>
                <CardBody p={5}>
                  <HStack spacing={3} mb={3}>
                    <Box bg="purple.100" borderRadius="full" p={2}>
                      <Icon as={MdSchool} color="purple.500" boxSize={6} />
                    </Box>
                    <Text fontWeight="bold" color="gray.700">Talleres</Text>
                  </HStack>
                  <Text fontSize="sm" color="gray.500" mb={3}>
                    Consulte los talleres y actividades disponibles e inscríbase en línea.
                  </Text>
                  <Button colorScheme="purple" variant="outline" size="sm" w="full">Ver Talleres →</Button>
                </CardBody>
              </Card>

              <Card shadow="md" _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }} transition="all 0.2s" cursor="pointer"
                onClick={() => navigate('/portal/imm/validar')}>
                <CardBody p={5}>
                  <HStack spacing={3} mb={3}>
                    <Box bg="green.100" borderRadius="full" p={2}>
                      <Icon as={MdVerifiedUser} color="green.500" boxSize={6} />
                    </Box>
                    <Text fontWeight="bold" color="gray.700">Validar Constancia</Text>
                  </HStack>
                  <Text fontSize="sm" color="gray.500" mb={3}>
                    Verifique la autenticidad de una constancia oficial mediante su código QR o token.
                  </Text>
                  <Button colorScheme="green" variant="outline" size="sm" w="full">Validar →</Button>
                </CardBody>
              </Card>
            </SimpleGrid>
          </Box>

          {/* Contacto */}
          <Card w="full" bg="gray.100" shadow="none">
            <CardBody>
              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} textAlign="center">
                <VStack spacing={1}>
                  <Icon as={MdAccessTime} color="#5b182b" boxSize={6} />
                  <Text fontWeight="bold" fontSize="sm">Horario de Atención</Text>
                  <Text fontSize="xs" color="gray.600">Lunes a Viernes</Text>
                  <Text fontSize="xs" color="gray.600">8:00 – 15:00 hrs</Text>
                </VStack>
                <VStack spacing={1}>
                  <Icon as={MdPlace} color="#5b182b" boxSize={6} />
                  <Text fontWeight="bold" fontSize="sm">Ubicación</Text>
                  <Text fontSize="xs" color="gray.600">Palacio Municipal</Text>
                  <Text fontSize="xs" color="gray.600">Totolac, Tlaxcala</Text>
                </VStack>
                <VStack spacing={1}>
                  <Icon as={MdSupportAgent} color="#5b182b" boxSize={6} />
                  <Text fontWeight="bold" fontSize="sm">Emergencias</Text>
                  <Text fontSize="xs" color="gray.600">En caso de peligro</Text>
                  <Text fontSize="xs" color="gray.600">Llame al 911</Text>
                </VStack>
              </SimpleGrid>
            </CardBody>
          </Card>

          <Text fontSize="xs" color="gray.400" textAlign="center">
            H. Ayuntamiento de Totolac · Tlaxcala · Para aclaraciones acuda a las oficinas del Ayuntamiento.
          </Text>
        </VStack>
      </Box>
    </Box>
  );
};

export default Portal2026Home;
